/**
 * Analytics helper — fires GA4 + Meta Pixel events with a single call.
 * Silently no-ops if analytics scripts haven't loaded (e.g. consent refused).
 */

export function trackEvent(name, params = {}) {
  try {
    if (typeof window !== "undefined" && typeof window.gtag === "function") {
      window.gtag("event", name, params);
    }
  } catch (_) { /* noop */ }
}

export function trackFbq(event, params = {}, options) {
  try {
    if (typeof window !== "undefined" && typeof window.fbq === "function") {
      if (options) window.fbq("trackCustom", event, params, options);
      else window.fbq("track", event, params);
    }
  } catch (_) { /* noop */ }
}

/** User clicked a "Réserver" CTA (any location). Intent event — NOT the completion.
 * Zenchef fires the actual "Schedule" event from their back-office when the booking is confirmed. */
export function trackReserveClick(source = "unknown") {
  const params = {
    source,
    page_path: typeof window !== "undefined" ? window.location.pathname : "",
    page_location: typeof window !== "undefined" ? window.location.href : "",
  };
  // GA4 — custom intent event
  trackEvent("reserve_click", params);
  // Meta — InitiateCheckout is the standard "started the flow" event.
  // Zenchef itself fires "Schedule" upon actual booking confirmation.
  trackFbq("InitiateCheckout", { content_category: "restaurant_reservation", source });
}

/** User clicked the phone number in the top bar or elsewhere. */
export function trackPhoneClick(source = "top_bar") {
  const params = { source, phone_number: "+33182001867" };
  trackEvent("phone_click", params);
  trackFbq("Contact", { source });
}

/** Gift card checkout initiated (before Stripe redirect). */
export function trackGiftCardCheckout(amount) {
  trackEvent("begin_checkout", { currency: "EUR", value: amount, items: [{ item_name: "Gift Card" }] });
  trackFbq("InitiateCheckout", { currency: "EUR", value: amount, content_category: "gift_card" });
}

/**
 * Unified lead event fired ONCE on the thank-you page.
 * @param {Object} params
 * @param {string} params.form_name        - "events" | "contact"
 * @param {string} params.content_category - "private_event" | "contact"
 * @param {string} [params.event_type]     - Wedding, Birthday, ... (events only)
 * @param {string|number} [params.guests]  - Guest count (events only)
 * @param {string} [params.subject]        - Subject (contact only)
 */
export function trackLead({ form_name, content_category, event_type = "", guests = "", subject = "" } = {}) {
  // GA4 standard lead event
  trackEvent("generate_lead", {
    form_name: form_name || "",
    content_category: content_category || "",
    event_type,
    guests: Number(guests) || 0,
    subject,
  });
  // Meta Pixel standard Lead event
  trackFbq("Lead", {
    content_category: content_category || form_name || "",
    form_name: form_name || "",
    event_type,
    subject,
    value: 0,
    currency: "EUR",
  });
}
